import { StudyState, UnitSystem } from '@/common/types';

export enum Scoring {
  unscorable = 'Unscorable',
  scoring = 'Scoring',
  review = 'Review',
  rejected = 'Rejected',
  approved = 'Completed',
  locked = 'Locked'
}

export interface ScoreSet {
  id: string;
  name: string;
  isSystemGenerated: boolean;
  measurementStart: string;
  measurementEnd: string;
  clinicName: string;
  lightsOff: string;
  lightsOn: string;
  desaturationRule: number;
  createdAt: string;
  createdBy: string;
  analystNotes: string;
  analystName: string;
  analystCertifications: string;
  physicianNotes: string;
  status: Scoring;
  isFailed: boolean;
  includedSections?: string[];
  studyState: StudyState;
  unitSystem?: UnitSystem;
}

export interface CloneScoreSetPayload {
  name: string;
  sourceScoreSet: string;
}

export enum SleepTime {
  LightsOff = 'Lights Off',
  LightsOn = 'Lights On'
}
